<template lang="pug">
  bf-flex.notifications.tabs.component
    router-link.personal( :to='{ name: "ref-notifications" }' :class='{ active: $route.name == "ref-notifications" }' ) 
      span {{ $t("Referral")}} 
      span.count( v-if='ref.length' ) {{ ref.length }}
    
    span.spacer |
    
    router-link.personal( :to='{ name: "per-notifications" }' :class='{ active: $route.name == "per-notifications" }' ) 
      span {{ $t("Personal")}}
      span.count( v-if='per.length' ) {{ per.length }}

    span.spacer( v-if='account.merchant' ) |
    
    router-link.business( v-if='account.merchant' :to='{ name: "biz-notifications" }' :class='{ active: $route.name == "biz-notifications" }' ) 
      span {{ $t("Business")}}
      span.count( v-if='bus.length' ) {{ bus.length }}
</template>

<script>
  export default {
    name: 'notifications.tabs',

    props: {
      biz: { type: Object, required: true, default: () => ({}) },
      account: { type: [ Object, Array ], required: true, default: () => ({}) },
      notifications: { type: Array, required: true, default: () => ({}) }
    },

    computed: {
      per() {
        if ( this.biz && this.account ) return this.notifications.filter( n => {
          switch( n.type ) {
            case 'msg' : return n.for == this.account.id
            case 'rsv' : return n.for == this.account.id && n.biz.user_id != this.account.id
            case 'cus' : return n.cus.business_id == this.biz.id
            case 'can' : return n.cus == this.account.id
            default: return false
          }
        })
        else return []
      },

      bus() {
        if ( this.biz && this.account ) return this.notifications.filter( n => {
          switch( n.type ) {
            case 'msg' : return n.for == this.account.id
            case 'rsv' : return n.for == this.account.id && n.biz.user_id == this.account.id
            case 'cus' : return n.cus.business_id == this.biz.id
            case 'can' : return n.for == this.account.id
            default: return false
          }
        })
        else return []
      },

      ref() {
        if ( this.biz && this.account ) return this.notifications.filter( n => {
          if( n.type == 'ref') return n.for == this.account.id
          else return false
          }
        )
        else return []
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .notifications.tabs
    justify-content flex-end
    .spacer
      margin 0 12px
      padding 5px 0
    .personal, .business
      padding 5px 10px
    .active
      text-align middle
      font-weight bold
      background orange 
      color white
      padding 5px 10px
      border-radius 5px
      vertical-align baseline
    .count
      display inline-block
      width 17px
      height 16px
      text-align center
      background red
      color white
      border-radius 50%
      margin-left 5px
      padding-right 1px
      padding-bottom 2px
</style>
